import React from 'react';
import { splitMatch } from '../../utils/globalSearch';
interface HighlightMatchProps {
  text: string;
  query: string;
}
export function HighlightMatch({
  text,
  query
}: HighlightMatchProps) {
  return <>
      {splitMatch(text, query).map((part, i) => part.match ? <mark key={i} className="bg-[#FEF3C7] text-inherit rounded-sm px-0.5 -mx-0.5" data-id="element-3360" data-mp="25t1z3ewcthi8">
            {part.text}
          </mark> : <React.Fragment key={i} data-id="element-3361" data-mp="1e48opxsmuygk">{part.text}</React.Fragment>)}
    </>;
}